import { IconButton } from '@mui/material'
import { Stack } from '@mui/system'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { ALL_NS } from '~/i18n/namespaces'
import { INavigateButtons } from './EFNavigateButton.model'
import { EFArrowSyncIcon, EFReplyIcon } from '../EFIcons'

export function EFNavigateButtons(props: INavigateButtons) {
  const { onRefetch } = props
  const { t } = useTranslation(ALL_NS)
  const navigate = useNavigate()

  const goBack = () => {
    navigate(-1) // Navigate back by one step
  }

  const refetch = () => {
    if (!onRefetch) return
    onRefetch()
  }
  return (
    <Stack
      direction='row'
      alignItems='center'
      marginX='0.5rem'
    >
      <IconButton
        id='btn-goBack'
        title={t('Button_GoBack')}
        onClick={goBack}
      >
        <EFReplyIcon />
      </IconButton>
      <IconButton
        id='btn-refetch'
        title={t('Message_RefreshData')}
        onClick={refetch}
      >
        <EFArrowSyncIcon />
      </IconButton>
    </Stack>
  )
}
